import * as React from 'react';

import { IMachineLearningExperiment } from '../../../Common/MachineLearningModels/IMachineLearningExperiment';

export type EntityTypeSelectionPreviewProps = {
  data: IMachineLearningExperiment;
};

export function EntityTypeSelectionPreview(props: EntityTypeSelectionPreviewProps): React.ReactElement {
  const properties: { name: string; type: string | null }[] = [];

  for (const column of props.data.baseEntityColumns || []) {
    properties.push({
      name: column,
      type: null,
    });
  }

  for (const joinedProperty in props.data.joinedEntities) {
    for (const entityTypeId in props.data.joinedEntities[joinedProperty]) {
      for (const property of props.data.joinedEntities[joinedProperty][entityTypeId]) {
        properties.push({
          name: property,
          type: null,
        });
      }
    }
  }

  properties.forEach(p => {
    if (props.data.hiddenProperties.includes(p.name)) {
      p.type = "Sensitive"
    }
    if (p.name === props.data.splitColumn) {
      p.type = "Split column"
    }
  });

  return (
    <Root>
      {properties.map((p) => (
        <Item>
          <span>{p.name}</span>
          {p.type && <ItemType> ({p.type})</ItemType>}
        </Item>
      ))}
    </Root>
  );
}

const Root = styled.ul`
  padding-left: 20px;
  list-style: disc;
  margin-bottom: 20px;
`;
const Item = styled.li`
  font-size: 14px;
`;

const ItemType = styled.span`
  font-weight: bold;
`;
